var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { optionsTree, countSubTrees } from 'helpers/Utils';
import { rules } from 'helpers/Validation';
import { Form } from 'components';
import { FieldType } from 'elements';
import { loading } from 'elements/Loading';
var FamilyForm = /** @class */ (function (_super) {
    __extends(FamilyForm, _super);
    function FamilyForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = function () {
            var family = _this.props.family;
            var subTreeCount = family ? countSubTrees(family, 'subfamilies') : 1;
            return [
                // NEXT: activate family images
                // {
                //   name: 'image',
                //   type: FieldType.Image,
                //   rules: rules().string()
                // },
                {
                    name: 'name',
                    type: FieldType.Text,
                    rules: rules()
                        .string()
                        .required(),
                    size: 5
                },
                {
                    name: 'parent',
                    type: FieldType.Select,
                    defaultValue: 'Familias',
                    rules: rules()
                        .number()
                        .integer(),
                    placeholder: 'Family',
                    options: optionsTree(_this.props.store.families.families, 'subfamilies', function (item, level) {
                        return { name: "".concat(level).concat(item.name), value: item.id };
                    }, function (item, level) {
                        return (family && item.id === family.id) || level + subTreeCount >= 3;
                    }),
                    size: 5
                }
            ];
        };
        return _this;
    }
    FamilyForm.prototype.render = function () {
        var family = this.props.family;
        var families = this.props.store.families;
        return (React.createElement("div", null,
            React.createElement(Form, { loading: ['post@family/', 'put@family/'], fields: this.fields(), values: family, store: families })));
    };
    FamilyForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.families
                    .read(props.match.params.id)
                    .then(function (family) { return ({ family: family }); })
                : undefined
        ]; }),
        observer
    ], FamilyForm);
    return FamilyForm;
}(Component));
export default FamilyForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/containers/FamilyForm.tsx
// module id = 1561
// module chunks = 0